import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";
import "./AIAgent.scss";

const AIAgentToggle = observer(() => {
  const { panelOpen: isOpen } = copilotStore;

  // Repointed from the Shell's context-blind Gemini panel to the in-app
  // copilot panel (same brain as /copilot, carries page context).
  const handleClick = () => {
    if (isOpen) copilotStore.closePanel();
    else copilotStore.openPanel();
  };

  return (
    <div 
      className={`aiAgentToggle ${isOpen ? "active" : ""}`} 
      onClick={handleClick}
      title="Toggle AI Agent"
    >
      <span className="material-symbols-outlined toggleIcon">side_navigation</span>
    </div>
  );
});

export default AIAgentToggle;
